import { Injectable } from "@angular/core";

import { ITabPageStorage } from "../../models/tab-page-storage";
import { NavigationStackService } from "src/app/features/shared/navigation-stack/services/navigation-stack.service";
import { SignalTree } from "../../types/signal-tree.type";
import { injectRequired } from 'src/app/infrastructure/functions/inject-required.function';


// Page-state (tab, tabhoogte, lijstposities) hoort bij één bezóek, niet bij een pagina-type: anders
// opent elk Domain op de tab die je het laatst op een wíllekeurig Domain koos, en is er geen verschil
// tussen "ik kom terug van beneden" en "ik daal opnieuw af". De backing-node is daarom het huidige
// frame in de navigatiestack.
@Injectable()
export class PageStorageService
{
    protected readonly _navigationStackService = injectRequired(NavigationStackService);

    // True zodra er een frame is om op te schrijven; lezers van page-/tab-state wachten hierop.
    readonly hydrated$$ = this._navigationStackService.hasFrame$$;

    // Getter, geen vastgelegde property: deze service wordt per pagina geïnstantieerd op het moment
    // dat het component zijn providers oplost — dus vóórdat _ngOnInit het bijbehorende frame pusht.
    get pageData$$(): SignalTree<ITabPageStorage> {
        return this._navigationStackService.frameNode();
    }
}
